/**
 * Единое окно подключения канала (us/10721, task/10729).
 * Архетип определяет содержимое шага «Авторизация»; каркас один для всех.
 * Avito отсутствует намеренно: канала в CRM не существует.
 */
export enum ConnectAuthArchetype {
  /** WhatsApp, Telegram — личный, MAX: QR — основной вход */
  QrSession = 'qrSession',
  /** Telegram Bot: одно поле токена */
  Token = 'token',
  /** ВКонтакте, Instagram: вход в отдельном окне провайдера */
  Provider = 'provider',
}

export enum ConnectStep {
  Params = 0,
  Auth = 1,
  Done = 2,
}

/** Состояния шага «Авторизация» — машина каркаса */
export enum AuthStepState {
  Loading = 'loading',
  QrReady = 'qrReady',
  QrExpired = 'qrExpired',
  QrScanned = 'qrScanned',
  CodeSent = 'codeSent',
  Password2fa = 'password2fa',
  Success = 'success',
  Error = 'error',
}

export interface AuthStepInfo {
  state: AuthStepState;
  /** Человеческий текст ошибки — показывается как есть */
  errorMessage?: string;
}

/** Шаг входа из CRM: голое значение SubStatus (без префикса auth:) */
export type IntegrationAuthSubStatus =
  | 'qr_ready'
  | 'qr_scanned'
  | 'pending_code'
  | 'pending_password'
  | 'reconnecting'
  | 'auth_failed'
  | (string & {});

export interface ConnectChannelConfig {
  archetype: ConnectAuthArchetype;
  /** Название канала для заголовка окна («Telegram — личный») */
  title: string;
  /**
   * Кроме входа у провайдера канал умеет вход по логину и паролю на своей
   * странице («серая» схема Instagram). Страница открывается во встроенном
   * фрейме поверх шага «Авторизация» (issue/10877).
   */
  hasEmbeddedLogin?: boolean;
}

/** Состояние окна провайдера (архетип «вход у провайдера», task/10731) */
export enum ProviderWindowState {
  /** Окно ещё не открывали или браузер заблокировал попап */
  Idle = 'idle',
  /** Окно открыто — ждём завершения входа */
  Waiting = 'waiting',
  /** Окно закрылось раньше, чем пришёл успех */
  Closed = 'closed',
}
